import React from "react";
import { TextArea } from "@heroui/react";

export function PortalTextArea({ label, value, onChange, readOnly = false, placeholder }) {
  return (
    <label className="portal-field">
      <span className="portal-field__label">{label}</span>
      <TextArea
        className="w-full"
        fullWidth
        variant="secondary"
        value={value ?? ""}
        readOnly={readOnly}
        placeholder={placeholder}
        onChange={(event) => onChange?.(event.target.value)}
      />
    </label>
  );
}
